import type { OnlinePlannerTimeDetails } from '../../Planner/Context/types';
import { assertNever } from '~/Partials/Utils/typeUtils';

export const getHoursPerWeek = (studyType: 'fullTime' | 'partTime', timeDetails: OnlinePlannerTimeDetails) => {
    switch (studyType) {
        case 'fullTime':
            return timeDetails.fullTimeHoursPerWeek;
        case 'partTime':
            return timeDetails.partTimeHoursPerWeek;
        default:
            assertNever(studyType);
    }
};
